<template>
  <div>
    <splashScreen></splashScreen>
  </div>
</template>

<!--No design, just to redirect-->

<script>

import * as api from '@/api'

import splashScreen from '../components/splashScreen';

export default {
  name: 'Start',
  components: {
    splashScreen
  },
  data() {
    return {
      c: null,
      fwcode: '',
      isvalid: 0,
      id_number: 0,
    };
  },
  async mounted() {
    this.fwcode = this.$route.query.c;
    api.checkCode({code: this.fwcode}).then(data=>{
      this.isvalid = data.data.valid;
      this.idnumber = data.data.idnumber;
      this.full_name = data.data.full_name;
      this.phone = data.data.phone;
      this.dollar_won = data.data.dollar_won;

      let img_start         = data.data.code1;
      let img_end           = data.data.code2;
      let winner_video_code = data.data.code3;

      if(this.isvalid === 1) {
        this.$router.push({name: "WheelPage", 'params': {
          code: this.fwcode,
            valid: this.isvalid,
            id_number: this.idnumber,
            winner_video_code: winner_video_code,
            img_start: img_start,
            img_end: img_end
        }});
      }
      if(this.isvalid === 2) {
        this.$router.push({name: "Info", 'params': {
          code: this.fwcode,
            valid: this.isvalid,
            id_number: this.idnumber,
            full_name: this.full_name,
            phone: this.phone,
            dollar_won: this.dollar_won,
        }});
      }
      if(this.isvalid === 0) {  // wrong code
        this.$router.push({name: "Info", 'params': {
            code: this.fwcode,
            valid: this.isvalid,
            id_number: this.idnumber
          }});
      }

    })
  }
}

</script>
